import React from 'react';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import RemoveIcon from '@mui/icons-material/Remove';
import { getComparisonTone } from '../../themes/labels';
import type { ComparisonBadgeProps } from './label.types';
import StatusChip from './StatusChip';

const ComparisonBadge: React.FC<ComparisonBadgeProps> = ({
  value,
  direction,
  meaning,
  label,
  size = 'small'
}) => {
  const tone = getComparisonTone(direction, meaning);
  const absValue = Math.abs(value);
  const formatted =
    label ??
    (direction === 'flat'
      ? '변동 없음'
      : `${direction === 'up' ? '+' : '-'}${absValue.toLocaleString()}`);

  const icon =
    direction === 'up' ? (
      <ArrowUpwardIcon />
    ) : direction === 'down' ? (
      <ArrowDownwardIcon />
    ) : (
      <RemoveIcon />
    );

  return (
    <StatusChip
      label={formatted}
      tone={tone}
      size={size}
      icon={icon}
    />
  );
};

export default ComparisonBadge;
